module.exports = __webpack_public_path__ + "img/43.05cb6273.png";